// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"2344":"46bdacfb","2756":"e29d1998","5961":"6814153d"}[chunkId] || chunkId) + "." + {"77":"ae42c5643d4dda27710f","589":"2ca58da2578576f1565a","2344":"b6be0d827f42cce2a059","2756":"66dd3c1c269f0c8bba07","5961":"171a15f2688c539a8c62"}[chunkId] + ".js";
};